import { MantineThemeOverride } from '@mantine/core';

export type TransferListTheme = NonNullable<MantineThemeOverride['components']>['TransferList'];

export const TransferList: TransferListTheme = {
  // todo: define
};
